<template>
    <div class="container">
        <div class="search search-bar">
            <el-form ref="queryFormRef" :inline="true" :model="search" class="demo-form-inline" size="mini">
                <el-form-item label="UUID：" prop="uuid">
                    <el-input v-model.trim="search.uuid" placeholder=" " @keyup.enter="Search"></el-input>
                </el-form-item>
                <el-form-item label="IMEI：" prop="imei">
                    <el-input v-model.trim="search.imei" placeholder=" " @keyup.enter="Search"></el-input>
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-select clearable v-model="search.status" @change="Search">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="未激活" :value="1"></el-option>
                        <el-option label="已激活" :value="2"></el-option>
                        <el-option label="已停止" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass" @click="Search">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="clearCondition">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="search-actions">
                <el-button type="primary" size="small" class="btnClass" :loading="uploadLoading"
                    @click="openUpload('generate')">导入IMEI和保活流量</el-button>
                <el-button type="primary" size="small" class="btnClass" :loading="uploadLoading"
                    @click="openUpload('mapping')">导入IMEI和UUID映射</el-button>
            </div>
        </div>
        <el-dialog v-model="uploadVisible" :title="uploadTitle" width="520px" :close-on-click-modal="false"
            class="keepalive-upload-dialog">
            <div class="upload-panel">
                <el-upload ref="uploadRef" class="upload-drag" drag :on-change="handleFileChange" action=""
                    :auto-upload="false" :show-file-list="true" accept=".xlsx,.xls" :limit="1" :on-exceed="handleExceed"
                    v-model:file-list="uploadFileList">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或点击上传</div>
                    <div class="el-upload__tip">仅支持 Excel 文件（.xlsx/.xls）</div>
                </el-upload>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button :disabled="uploadLoading" @click="uploadVisible = false">取消</el-button>
                    <el-button type="primary" :loading="uploadLoading" @click="submitUpload">上传</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 列表 -->
        <el-table :data="list" size="mini">
            <el-table-column label="IMEI" min-width="140" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.imei }}</span>
                </template>
            </el-table-column>
            <el-table-column label="UUID" min-width="240" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.uuid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="套餐Token" min-width="260" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.package_token }}</span>
                </template>
            </el-table-column>
            <el-table-column label="套餐vsimid" width="100">
                <template v-slot="scope">
                    <span>{{ scope.row.pkg_type_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="80">
                <template v-slot="scope">
                    <span>{{ getStatusText(scope.row.status) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="开始时间" width="170">
                <template v-slot="scope">
                    <span>{{ scope.row.start_time ? util.dateFormat(scope.row.start_time) : '--:--:--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="结束时间" width="170">
                <template v-slot="scope">
                    <span>{{ scope.row.end_time ? util.dateFormat(scope.row.end_time) : '--:--:--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="流量上限" width="100">
                <template v-slot="scope">
                    <span>{{ formatDataLimit(scope.row.data_limit) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="已用流量" width="100">
                <template v-slot="scope">
                    <span>{{ formatDataLimit(scope.row.data_used) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="170">
                <template v-slot="scope">
                    <span>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page" :page-size="search.limit"
            layout="total, prev, pager, next" :total="total" background>
        </el-pagination>
    </div>
</template>

<script type="text/ecmascript-6">
import util from '../../../util/util'
import { getRegion } from '../../../util/util'

export default {
    name: 'keepalivelist',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            util: util,
            search: {
                page: 1,
                limit: 16,
                uuid: '',
                imei: '',
                status: ''
            },
            list: [],
            total: 0,
            uploadVisible: false,
            uploadLoading: false,
            uploadFile: null,
            uploadFileList: [],
            uploadType: 'generate'
        }
    },
    computed: {
        uploadTitle() {
            return this.getUploadTitle()
        }
    },
    watch: {},
    methods: {
        handleCurrentChange(val) {
            this.search.page = val
            this.Search()
        },
        Search() {
            let filter = {
                ...this.search
            }
            this.api.SimKeepAliveList(filter).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.list || []
                    this.total = res.data.data.page_info.total
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        clearCondition() {
            this.reset()
            this.Search()
        },
        openUpload(type) {
            this.uploadType = type || 'generate'
            this.uploadVisible = true
            this.uploadFile = null
            this.uploadFileList = []
            if (this.$refs.uploadRef) {
                this.$refs.uploadRef.clearFiles()
            }
        },
        getUploadUrl() {
            if (this.uploadType === 'mapping') return this.uri.SimKeepAliveMapping
            return this.uri.SimKeepAliveGenerate
        },
        getUploadTitle() {
            return this.uploadType === 'mapping' ? '导入IMEI和UUID映射' : '导入IMEI和保活流量'
        },
        handleFileChange(file) {
            this.uploadFile = file.raw
            this.uploadFileList = [file]
        },
        handleExceed(files) {
            const file = files[0]
            this.uploadFile = file
            this.uploadFileList = [file]
            if (this.$refs.uploadRef) {
                this.$refs.uploadRef.clearFiles()
            }
        },
        submitUpload() {
            const uploadFile = this.uploadFile && this.uploadFile.raw ? this.uploadFile.raw : this.uploadFile
            if (!uploadFile) {
                this.$message.error('请上传文件')
                return
            }
            this.uploadLoading = true
            let formData = new FormData()
            formData.append("file", uploadFile)
            let timestamp = new Date().getTime()
            let header = {
                'token': JSON.parse(localStorage.getItem('user_info'))["token"],
                'client_time': parseInt(timestamp / 1000),
                'uid': JSON.parse(localStorage.getItem('user_info'))["id"],
                'request_id': timestamp,
                'CA-KEYS': 'client_time,request_id,token,uid',
                region: getRegion('region_change')
            }
            const uploadUrl = this.getUploadUrl()
            header.signature = this.signature(timestamp, {
                method: 'POST',
                data: "",
                url: uploadUrl
            }, header)
            fetch(uploadUrl, {
                method: 'POST',
                body: formData,
                headers: header,
            })
                .then(async (res) => {
                    const ct = (res.headers.get('content-type') || '').toLowerCase()
                    if (ct.includes('application/json') || ct.includes('text/json')) {
                        const data = await res.json()
                        this.uploadLoading = false
                        if (data.code == 200) {
                            this.$message.success('上传成功')
                            this.uploadVisible = false
                            this.Search()
                            return
                        }
                        this.$message.error('上传失败' + (data.msg || ''))
                        return
                    }
                    if (!res.ok) {
                        const errText = await res.text()
                        this.uploadLoading = false
                        this.$message.error('上传失败' + errText.slice(0, 200))
                        return
                    }
                    const blob = await res.blob()
                    this.uploadLoading = false
                    const disposition = res.headers.get('content-disposition') || ''
                    const filename = this.filenameFromContentDisposition(disposition) || 'keep_alive_result.xlsx'
                    const objectUrl = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = objectUrl
                    link.download = filename
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(objectUrl)
                    const summary = res.headers.get('x-result-summary')
                    this.$message.success(
                        summary ? `结果已下载（${summary}）` : '上传成功，结果已下载'
                    )
                    this.uploadVisible = false
                    this.Search()
                })
                .catch(() => {
                    this.uploadLoading = false
                    this.$message.error('上传失败')
                })
        },
        filenameFromContentDisposition(disposition) {
            if (!disposition) return ''
            const star = /filename\*=(?:UTF-8''|utf-8'')([^;\s]+)/i.exec(disposition)
            if (star) {
                try {
                    return decodeURIComponent(star[1].replace(/["']/g, '').trim())
                } catch (e) {
                    return star[1]
                }
            }
            const quoted = /filename="([^"]+)"/i.exec(disposition)
            if (quoted) return quoted[1]
            const plain = /filename=([^;\s]+)/i.exec(disposition)
            if (plain) return plain[1].replace(/^["']|["']$/g, '')
            return ''
        },
        reset() {
            this.search = {
                ...this.search,
                uuid: '',
                imei: '',
                status: ''
            }
        },
        getStatusText(status) {
            const statusMap = {
                0: '未激活',
                1: '已激活',
                2: '已停止'
            }
            return statusMap[status] || '未知'
        },
        formatDataLimit(dataLimitKb) {
            if (dataLimitKb === null || dataLimitKb === undefined || dataLimitKb === '') return '--'
            const kb = Number(dataLimitKb)
            if (Number.isNaN(kb)) return '--'
            if (kb < 1024) return `${kb.toFixed(0)}KB`

            const mb = kb / 1024
            return mb >= 1024 ? `${(mb / 1024).toFixed(1)}GB` : `${mb.toFixed(0)}MB`
        }
    },
    filters: {},
    mounted() {
        this.Search()
    },
    created() { }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
    .search-bar {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding-right: 16px;
    }
    .search-actions {
        display: flex;
        gap: 12px;
        padding-bottom: 12px;
        flex-shrink: 0;
    }
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }
}
.keepalive-upload-dialog {
  ::v-deep(.el-dialog__body) {
    padding: 20px 24px 8px;
  }
  .upload-panel {
    display: flex;
    justify-content: center;
  }
  ::v-deep(.upload-drag) {
    width: 100%;
  }
  ::v-deep(.el-upload-dragger) {
    width: 100%;
    height: 180px;
    padding: 18px 12px;
  }
  ::v-deep(.el-upload__text) {
    color: #303133;
    font-size: 14px;
    margin-top: 6px;
  }
  ::v-deep(.el-upload__tip) {
    margin-top: 6px;
    color: #909399;
    font-size: 12px;
  }
}
</style>
